import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AlterarSenha.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCheckCircle,
  faEye,
  faEyeSlash,
  faKey,
  faLock,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";

const AlterarSenha = () => {
  const [formData, setFormData] = useState({
    senha_atual: "",
    nova_senha: "",
    confirmar_senha: "",
  });

  const [mostrarSenha, setMostrarSenha] = useState({
    senha_atual: false,
    nova_senha: false,
    confirmar_senha: false,
  });

  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleMostrarSenha = (campo) => {
    setMostrarSenha((prev) => ({
      ...prev,
      [campo]: !prev[campo],
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setMensagem("");
    setErro("");

    if (formData.nova_senha.length < 6) {
      setErro("A nova senha deve ter pelo menos 6 caracteres.");
      return;
    }

    if (formData.nova_senha !== formData.confirmar_senha) {
      setErro("A nova senha e a confirmação devem ser iguais.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/alterar_senha.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erro desconhecido.");
      }

      setMensagem(data.message || "Senha alterada com sucesso!");
      setFormData({
        senha_atual: "",
        nova_senha: "",
        confirmar_senha: "",
      });
    } catch (error) {
      setErro("Erro: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const renderPasswordField = ({
    id,
    name,
    label,
    placeholder,
    autoComplete,
  }) => {
    const isVisible = mostrarSenha[name];

    return (
      <div className="alterar-field">
        <label htmlFor={id}>{label}</label>

        <div className="alterar-input-wrap">
          <FontAwesomeIcon icon={faLock} className="alterar-input-icon" />

          <input
            type={isVisible ? "text" : "password"}
            id={id}
            name={name}
            placeholder={placeholder}
            value={formData[name]}
            onChange={handleChange}
            required
            autoComplete={autoComplete}
          />

          <button
            type="button"
            className="alterar-eye-button"
            onClick={() => toggleMostrarSenha(name)}
            title={isVisible ? "Ocultar senha" : "Mostrar senha"}
            aria-label={isVisible ? "Ocultar senha" : "Mostrar senha"}
          >
            <FontAwesomeIcon icon={isVisible ? faEyeSlash : faEye} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="alterar-container">
      <section className="alterar-shell">
        <div className="alterar-info-card">
          <div className="alterar-info-icon">
            <FontAwesomeIcon icon={faShieldHalved} />
          </div>

          <span className="alterar-eyebrow">Segurança da conta</span>

          <h1>Atualize sua senha com segurança.</h1>

          <p>
            Use uma senha forte e evite repetir senhas utilizadas em outros
            sistemas. Depois da alteração, utilize a nova senha nos próximos
            acessos ao Nórea CRM.
          </p>

          <div className="alterar-check-list">
            <div>
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>Mínimo de 6 caracteres</span>
            </div>

            <div>
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>Evite senhas óbvias ou compartilhadas</span>
            </div>

            <div>
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>Subusuários alteram apenas a própria senha</span>
            </div>
          </div>
        </div>

        <div className="alterar-form-card">
          <button
            type="button"
            className="alterar-back-button"
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Voltar</span>
          </button>

          <div className="alterar-header">
            <div className="alterar-header-icon">
              <FontAwesomeIcon icon={faKey} />
            </div>

            <h2>Alterar Senha</h2>
            <p>Informe sua senha atual e escolha uma nova senha.</p>
          </div>

          {mensagem && (
            <div className="alterar-alert alterar-alert-success">
              {mensagem}
            </div>
          )}

          {erro && (
            <div className="alterar-alert alterar-alert-error">
              {erro}
            </div>
          )}

          <form onSubmit={handleSubmit} className="alterar-form-body">
            {renderPasswordField({
              id: "senha_atual",
              name: "senha_atual",
              label: "Senha atual",
              placeholder: "Digite sua senha atual",
              autoComplete: "current-password",
            })}

            {renderPasswordField({
              id: "nova_senha",
              name: "nova_senha",
              label: "Nova senha",
              placeholder: "Digite a nova senha",
              autoComplete: "new-password",
            })}

            {renderPasswordField({
              id: "confirmar_senha",
              name: "confirmar_senha",
              label: "Confirmar nova senha",
              placeholder: "Confirme a nova senha",
              autoComplete: "new-password",
            })}

            <button
              type="submit"
              className="alterar-submit-button"
              disabled={loading}
            >
              {loading ? "Alterando..." : "Alterar Senha"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default AlterarSenha;